import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import i18n from '@/i18n/config';

export type Language = 'en' | 'fr' | 'ar';
export type Direction = 'ltr' | 'rtl';

interface LanguageState {
  language: Language;
  direction: Direction;
  setLanguage: (language: Language) => void;
  _hasHydrated: boolean;
  setHasHydrated: (hasHydrated: boolean) => void;
}

const getDirection = (language: Language): Direction => {
  return language === 'ar' ? 'rtl' : 'ltr';
};

export const useLanguage = create<LanguageState>()(
  persist(
    (set) => ({
      language: 'en',
      direction: 'ltr',
      _hasHydrated: false,

      setLanguage: (language: Language) => {
        const direction = getDirection(language);

        // Update i18next
        i18n.changeLanguage(language);

        // Update HTML attributes
        document.documentElement.lang = language;
        document.documentElement.dir = direction;

        // Update state
        set({ language, direction });
      },

      setHasHydrated: (hasHydrated: boolean) => {
        set({ _hasHydrated: hasHydrated });
      },
    }),
    {
      name: 'language',
      onRehydrateStorage: () => (state) => {
        // After hydration, sync language with i18next and HTML
        if (state) {
          const { language, setLanguage } = state;
          setLanguage(language);
          state.setHasHydrated(true);
        }
      },
    }
  )
);
